module.exports = __webpack_public_path__ + "static/media/google-sign-in.be91afd8.svg";